var bcSfFilterSettings = {
        general: {
            limit: bcSfFilterConfig.custom.products_per_page,
            loadProductFirst: false,
            numberFilterTree: 2,
            showLimitList: "24,36,48",
            showLoading: true,
        }
    },
    bcSfFilterTemplate = {
        productGridItemHtml: '<li class="productgrid--item {{customClass}} show-actions--mobile" data-product-item data-product-quickshop-url="{{itemUrl}}" data-quickshop-hash="{{itemDataSha256}}"><div class="productitem" data-product-item-content><a class="productitem--image-link" href="{{itemUrl}}" tabindex="-1" data-product-page-link><figure class="productitem--image" data-product-item-image>{{itemImages}}{{itemLabels}}</figure></a><div class="productitem--info">{{itemSwatch}}{{emphasizePrice}}<h2 class="productitem--title"><a href="{{itemUrl}}" data-product-page-link>{{itemTitle}}</a></h2>{{itemVendor}}{{noEmphasizePrice}}<span class="stamped-product-reviews-badge" data-id="{{itemId}}"></span>{{itemDescription}}</div>{{itemActions}}</div>{{itemQuickShopSettings}}</li>',
        previousActiveHtml: '<li class="pagination--previous"><a class="pagination--item" href="{{itemUrl}}"><span class="pagination--chevron-left" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg></span>' + bcSfFilterConfig.label.prev + "</a></li>",
        previousDisabledHtml: "",
        nextActiveHtml: '<li class="pagination--next"><a class="pagination--item" href="{{itemUrl}}">' + bcSfFilterConfig.label.next + '<span class="pagination--chevron-right" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg></span></a></li>',
        nextDisabledHtml: "",
        pageItemHtml: '<li><a class="pagination--item" href="{{itemUrl}}">{{itemTitle}}</a></li>',
        pageItemSelectedHtml: '<li class="pagination--active"><span class="pagination--item">{{itemTitle}}</span></li>',
        pageItemRemainHtml: '<li class="pagination--ellipsis"><span class="pagination--item">{{itemTitle}}</span></li>',
        paginateHtml: '<div class="pagination--container"><ul class="pagination--inner">{{previous}}{{pageItems}}{{next}}</ul></div>',
        sortingHtml: '<label class="utils-sortby-title" for="bc-sf-filter-top-sorting-select">' + bcSfFilterConfig.label.sorting + '</label><div class="utils-sortby-select form-field-select-wrapper no-label"><select id="bc-sf-filter-top-sorting-select" class="form-field form-field-select">{{sortingItems}}</select><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg></div>',
        showLimitHtml: '<li><span class="utils-showby-title">' + bcSfFilterConfig.label.show_per_page + "</span></li>{{showLimitItems}}"
    };

function truncateString(e, t) {
    return e.length <= t ? e : e.slice(0, t) + "..."
}

function buildImage(e, t, i) {
    e || (e = {
        src: bcSfFilterConfig.general.no_image_url,
        width: 480,
        height: 480,
        aspect_ratio: 1
    });
    var a = t.split("x")[0],
        r = a * e.aspect_ratio,
        s = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='X' height='Y'></svg>";
    s = s.replace("X", a).replace("Y", r).replace(" ", "%20");
    var l = '<img data-src="' + bcsffilter.optimizeImage(e.src, t) + '" class="lazy ' + i + '" alt="{{itemTitle}}" data-rimg="lazy" data-rimg-scale="1" data-rimg-template="' + bcsffilter.optimizeImage(e.src, "{size}") + '" data-rimg-max="' + e.width + "x" + e.height + '" data-rimg-crop srcset="' + s + '">';
    return l += "<div data-rimg-canvas></div>"
}

function buildActions(e, t, i, a) {
    var r = "",
        s = "Default Title" != t.option_title;
    if (1 == i.custom.enable_quick_look || 1 == i.custom.enable_quick_buy) {
        i.label.quick_look_text;
        var l = i.label.quick_buy_text,
            o = "productitem--action-trigger productitem--action-atc button-primary";
        s && (l = i.label.quick_choose_options), e.available || (l = i.label.sold_out, o += " disabled");
        var c = e.compare_at_price_min > e.price_min,
            n = e.price_min != e.price_max,
            p = "",
            m = n ? "price--varies" : "",
            d = c ? "visible" : "";
        if (e.tags.indexOf("Hikvision") > -1 && !isCustomer) p = '<a href="/account" class="productitem--price signIn">Sign In for Price</a>';
        else {
            p += '<div class="productitem--price ' + m + '">', p += '<div class="price--compare-at ' + d + '" data-price-compare-at>';
            var g = '<span class="money" data-currentprice="' + e.compare_at_price_min + '">' + a.formatMoney(e.compare_at_price_min) + "</span>";
            n && c ? p += i.label.range_html.replace(/{{ price }}/g, g) : c ? p += g : i.custom.emphasize_price ? p += '<span class="price--spacer"></span>' : p += '<span class="money"></span>', p += "</div>", p += '<div class="price--main" data-price>';
            var u = '<span class="money" data-currentprice="' + e.price_min + '">' + a.formatMoney(e.price_min) + "</span>";
            p += n ? i.label.range_html.replace(/{{ price }}/g, u) : u, p += "</div>", p += "</div>"
        }
        if (r += '<div class="productitem--actions" data-product-actions><div class="listViewPrice">' + p + "</div>", i.custom.enable_quick_look && (r += '<div class="productitem--action"><a class="button-secondary productitem--action-trigger" href="' + e.url + '">View product</a></div>'), i.custom.enable_quick_buy) {
            if (s) h = " data-quickshop-slim ";
            else var h = " data-quick-buy ";
            e.tags.indexOf("Hikvision") > -1 && !isCustomer || (r += '<div class="productitem--action"><button class="' + o + '" tabindex="1" type="button" aria-label="' + l + '"' + h + 'data-variant-id="' + e.variants[0].id + '"', e.available || (r += " disabled"), r += ">", r += '<span class="atc-button--text">' + l + "</span>", r += '<span class="atc-button--icon">', r += '<svg aria-hidden="true" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" > <g fill-rule="nonzero" fill="currentColor"> <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"/><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"/> </g> </svg>', r += "</span>", r += "</button>", r += "</div>")
        }
        r += "</div>"
    }
    return r
}

function buildSwatch(e) {
    var t = "",
        i = [],
        a = [],
        r = 1;
    if (bcSfFilterConfig.custom.swatches_enable && bcSfFilterConfig.custom.swatch_trigger) {
        var s = bcSfFilterConfig.custom.swatches_custom_colors.split("\n");
        if (e.variants.forEach(function(e) {
                var t = "";
                if (e.options = e.merged_options, e.merged_options.forEach(function(e, i) {
                        var s = e.split(":")[0].trim(),
                            l = e.split(":")[1].trim();
                        s.toLowerCase() == bcSfFilterConfig.custom.swatch_trigger && -1 == a.indexOf(l.toLowerCase()) && (t = l, a.push(l.toLowerCase()), r = i + 1)
                    }), t) {
                    var l = '<label><input class="productitem--swatches-input" type="radio" name="swatch" value="{{swatchValue}}"><div class="productitem--swatches-swatch-wrapper" data-swatch-tooltip="{{swatchValue}}" data-swatch><div class="productitem--swatches-swatch"><div class="productitem--swatches-swatch-inner" style="background-color:{{backgroundColor}}; background-color:{{customColor}}; background-image:url({{backgroundImage}}); background-size:cover"></div></div></div></label>',
                        o = "";
                    s.forEach(function(e) {
                        if (2 == e.split(":").length) {
                            var i = e.split(":")[0].trim().toLowerCase(),
                                a = e.split(":")[1].trim().toLowerCase();
                            i == t.toLowerCase() && (o = a)
                        }
                    });
                    var c = bcsffilter.slugify(t),
                        n = c.split("-").pop(),
                        p = "";
                    p = "variant_image" == bcSfFilterConfig.custom.swatches_option_style && e.image ? bcsffilter.optimizeImage(e.image, "50x") : bcSfFilterMainConfig.general.file_url.split("?")[0] + c + ".png", l = (l = (l = (l = l.replace(/{{swatchValue}}/g, t)).replace(/{{backgroundColor}}/g, n)).replace(/{{backgroundImage}}/g, p)).replace(/{{customColor}}/g, o), i.push(l)
                }
            }), a.length > 0) {
            t = '<div class="productitem--swatches {{swatchClass}}" data-swatches><script type="application/json" data-swatch-data>{"hash": "{{itemDataSha256}}","swatchOptionKey": "{{swatchOptionKey}}","variants": {{variantsJson}}}<\/script><form class="productitem--swatches-container" data-swatches-container>' + i.join(" ") + '</form><button class="productitem--swatches-count-wrapper" data-swatch-count-wrapper><div class="productitem--swatches-count" data-swatch-count>+</div></button></div>';
            var l = "square" == bcSfFilterConfig.custom.swatches_shape && "variant_image" == bcSfFilterConfig.custom.swatches_option_style ? "swatches-variant-images-square" : "";
            t = (t = (t = t.replace(/{{swatchClass}}/g, l)).replace(/{{swatchOptionKey}}/g, "option" + r)).replace(/{{variantsJson}}/g, JSON.stringify(e.variants))
        }
    }
    return t
}

function sha256(e) {
    function t(e, t) {
        return e >>> t | e << 32 - t
    }
    for (var i, a, r = Math.pow, s = r(2, 32), l = "", o = [], c = 8 * e.length, n = sha256.h = sha256.h || [], p = sha256.k = sha256.k || [], m = p.length, d = {}, g = 2; m < 64; g++)
        if (!d[g]) {
            for (i = 0; i < 313; i += g) d[i] = g;
            n[m] = r(g, .5) * s | 0, p[m++] = r(g, 1 / 3) * s | 0
        } for (e += ""; e.length % 64 - 56;) e += "\0";
    for (i = 0; i < e.length; i++) {
        if ((a = e.charCodeAt(i)) >> 8) return;
        o[i >> 2] |= a << (3 - i) % 4 * 8
    }
    for (o[o.length] = c / s | 0, o[o.length] = c, a = 0; a < o.length;) {
        var u = o.slice(a, a += 16),
            h = n;
        for (n = n.slice(0, 8), i = 0; i < 64; i++) {
            var v = u[i - 15],
                f = u[i - 2],
                b = n[0],
                _ = n[4],
                w = n[7] + (t(_, 6) ^ t(_, 11) ^ t(_, 25)) + (_ & n[5] ^ ~_ & n[6]) + p[i] + (u[i] = i < 16 ? u[i] : u[i - 16] + (t(v, 7) ^ t(v, 18) ^ v >>> 3) + u[i - 7] + (t(f, 17) ^ t(f, 19) ^ f >>> 10) | 0);
            (n = [w + ((t(b, 2) ^ t(b, 13) ^ t(b, 22)) + (b & n[1] ^ b & n[2] ^ n[1] & n[2])) | 0].concat(n))[4] = n[4] + w | 0
        }
        for (i = 0; i < 8; i++) n[i] = n[i] + h[i] | 0
    }
    for (i = 0; i < 8; i++)
        for (a = 3; a + 1; a--) {
            var y = n[i] >> 8 * a & 255;
            l += (y < 16 ? 0 : "") + y.toString(16)
        }
    return l
}

function customizeJsonProductData(e) {
    for (var t = 0; t < e.variants.length; t++) {
        var i = e.variants[t],
            a = e.images.filter(function(e) {
                return e.src == i.image
            });
        a.length > 0 ? i.featured_image = {
            id: a[0].id,
            product_id: e.id,
            position: a[0].position,
            created_at: "",
            updated_at: "",
            alt: null,
            width: a[0].width,
            height: a[0].height,
            src: a[0].src,
            variant_ids: [i.id]
        } : i.featured_image = ""
    }
    var r = bcsffilter;
    return {
        id: e.id,
        title: e.title,
        handle: e.handle,
        vendor: e.vendor,
        variants: e.variants,
        url: r.buildProductItemUrl(e),
        options_with_values: e.options_with_values,
        images: e.images,
        images_info: e.images_info,
        available: e.available,
        price_min: e.price_min,
        price_max: e.price_max,
        compare_at_price_min: e.compare_at_price_min,
        compare_at_price_max: e.compare_at_price_max
    }
}
BCSfFilter.prototype.buildProductGridItem = function(e, t, i) {
    var a = e.images_info,
        r = !e.available,
        s = e.compare_at_price_min > e.price_min,
        l = e.price_min != e.price_max,
        o = e.variants[0];
    if (null !== getParam("variant") && "" != getParam("variant")) {
        var c = e.variants.filter(function(e) {
            return e.id == getParam("variant")
        });
        void 0 !== c[0] && (o = c[0])
    } else
        for (var n = 0; n < e.variants.length; n++)
            if (e.variants[n].available) {
                o = e.variants[n];
                break
            } var p = bcSfFilterTemplate.productGridItemHtml,
        m = "imagestyle--" + bcSfFilterConfig.custom.product_grid_image_style;
    s && (m += " productitem--sale"), bcSfFilterConfig.custom.emphasize_price && (m += " productitem--emphasis"), p = p.replace(/{{customClass}}/g, m);
    var d = "";
    a.length > 0 ? (a.length > 1 && bcSfFilterConfig.custom.product_grid_show_second_image && (d += buildImage(a[1], "512x", "productitem--image-alternate")), d += buildImage(a[0], "512x", "productitem--image-primary")) : d += buildImage(null, "512x", "productitem--image-primary"), p = p.replace(/{{itemImages}}/g, d);
    var g = a.length > 0 ? this.optimizeImage(a[0].src, "512x") : bcSfFilterConfig.general.no_image_url;
    p = p.replace(/{{itemThumbUrl}}/g, g);
    var u = "";
    if (r) u += '<span class="productitem--badge badge--soldout">' + bcSfFilterConfig.label.sold_out + "</span>";
    else if (s && bcSfFilterConfig.custom.product_sales_badge) {
        var h = e.compare_at_price_min - e.price_min,
            v = Math.round(100 * h / e.compare_at_price_max),
            f = (this.formatMoney(h), "<span data-price-percent-saved>" + v + "</span>");
        switch (u += '<span class="productitem--badge badge--sale" data-badge-sales>', bcSfFilterConfig.custom.product_sales_badge_style) {
            case "percentile":
                u += bcSfFilterConfig.label.sale_percentile_html.replace(/{{ saved }}/g, f);
                break;
            case "money":
                u += bcSfFilterConfig.label.sale_money_html.replace(/{{ saved }}/g, this.formatMoney(h));
                break;
            default:
                u += bcSfFilterConfig.label.sale
        }
        u += "</span>"
    }
    p = p.replace(/{{itemLabels}}/g, u);
    var b = buildSwatch(e);
    p = p.replace(/{{itemSwatch}}/g, b);
    var _ = "";
    if (e.tags.indexOf("Hikvision") > -1 && !isCustomer) _ = '<a href="/account" class="productitem--price signIn">Sign In for Price</a>';
    else {
        var w = s ? "visible" : "";
        _ += '<div class="productitem--price ' + (l ? "price--varies" : "") + '">', _ += '<div class="price--main" data-price>';
        var y = '<span class="money" data-currentprice="' + e.price_min + '">' + this.formatMoney(e.price_min) + "</span>";
        _ += l ? bcSfFilterConfig.label.range_html.replace(/{{ price }}/g, y) : y, _ += "</div>", _ += '<div class="price--compare-at ' + w + '" data-price-compare-at>';
        var S = '<span class="money" data-currentprice="' + e.compare_at_price_min + '">' + this.formatMoney(e.compare_at_price_min) + "</span>";
        l && s ? _ += bcSfFilterConfig.label.range_html.replace(/{{ price }}/g, S) : s ? _ += S : bcSfFilterConfig.custom.emphasize_price ? _ += '<span class="price--spacer"></span>' : _ += '<span class="money"></span>', _ += "</div>", _ += "</div>"
    }
    var C = "",
        F = "";
    bcSfFilterConfig.custom.emphasize_price ? C += _ : F += _, p = (p = p.replace(/{{emphasizePrice}}/g, C)).replace(/{{noEmphasizePrice}}/g, F);
    var x = "";
    bcSfFilterConfig.custom.show_vendor && "" !== e.vendor && (x += '<h3 class="productitem--vendor">' + e.vendor + "</h3>"), p = p.replace(/{{itemVendor}}/g, x);
    var P = e.body_html;
    P = P.indexOf("<em>") > -1 ? '<div class="productitem--description">' + (P = (P = (P = (P = P.split("</em>"))[0]).split("<em>"))[1]) + "</div>" : "";
    var k = [];
    for (n = 0; n < e.tags.length; n++) {
        var I = e.tags[n];
        if (I.indexOf("Icon") > -1) {
            var T = I + ".png";
            k.push(T)
        }
    }
    if (k.length) {
        var H = "";
        for (n = 0; n < k.length; n++) H += '<img class="lazy" data-src="//cdn.shopify.com/s/files/1/0364/6875/2429/files/' + k[n] + '" />';
        P += '<div class="productIcons">' + H + "</div>"
    }
    p = p.replace(/{{itemDescription}}/g, P);
    var j = buildActions(e, o, bcSfFilterConfig, this);
    p = (p = (p = (p = (p = p.replace(/{{itemActions}}/g, j)).replace(/{{itemId}}/g, e.id)).replace(/{{itemHandle}}/g, e.handle)).replace(/{{itemTitle}}/g, e.title)).replace(/{{itemUrl}}/g, this.buildProductItemUrl(e));
    var L = "";
    bcSfFilterConfig.custom.enable_quick_buy && (L += '<script type="application/json" data-quick-buy-settings>', L += "{", L += '"cart_redirection": ' + bcSfFilterConfig.custom.cart_redirect + ",", L += '"money_format": "' + bcSfFilterConfig.custom.money_format + '"', L += "}", L += "<\/script>"), p = p.replace(/{{itemQuickShopSettings}}/g, L);
    var Q = sha256(JSON.stringify(e.id));
    return p = p.replace(/{{itemDataSha256}}/g, Q)
}, BCSfFilter.prototype.buildProductListItem = function(e, t, i) {
    return this.buildProductGridItem(e, t, i)
}, BCSfFilter.prototype.buildPagination = function(e) {
    setTimeout(function() {
        lazyLoadInstance.update()
    }, 100), console.log(1);
    var t = parseInt(this.queryParams.page),
        i = Math.ceil(e / this.queryParams.limit);
    if (1 == i) return jQ(this.selector.pagination).html(""), !1;
    if ("default" == this.getSettingValue("general.paginationType")) {
        var a = bcSfFilterTemplate.paginateHtml,
            r = t > 1 ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        r = r.replace(/{{itemUrl}}/g, this.buildToolbarLink("page", t, t - 1)), a = a.replace(/{{previous}}/g, r);
        var s = t < i ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
        s = s.replace(/{{itemUrl}}/g, this.buildToolbarLink("page", t, t + 1)), a = a.replace(/{{next}}/g, s);
        for (var l = [], o = t - 1; o > t - 3 && o > 0; o--) l.unshift(o);
        t - 4 > 0 && l.unshift("..."), t - 4 >= 0 && l.unshift(1), l.push(t);
        for (var c = [], n = t + 1; n < t + 3 && n <= i; n++) c.push(n);
        t + 3 < i && c.push("..."), t + 3 <= i && c.push(i);
        for (var p = "", m = l.concat(c), d = 0; d < m.length; d++) "..." == m[d] ? p += bcSfFilterTemplate.pageItemRemainHtml : p += m[d] == t ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml, p = (p = p.replace(/{{itemTitle}}/g, m[d])).replace(/{{itemUrl}}/g, this.buildToolbarLink("page", t, m[d]));
        a = a.replace(/{{pageItems}}/g, p), a = jQ.parseHTML(a), jQ(this.selector.pagination).html(a)
    }
}, BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty("sortingHtml")) {
        jQ(this.selector.topSorting).html("");
        var e = this.getSortingList();
        if (e) {
            var t = "";
            for (var i in e) t += '<option value="' + i + '">' + e[i] + "</option>";
            var a = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, t);
            a = jQ.parseHTML(a), jQ(this.selector.topSorting).html(a), jQ(this.selector.topSorting + " select").val(this.queryParams.sort)
        }
    }
}, BCSfFilter.prototype.buildFilterShowLimit = function() {
    if (bcSfFilterTemplate.hasOwnProperty("showLimitHtml")) {
        jQ(this.selector.topShowLimit).html("");
        var e = this.getSettingValue("general.showLimitList");
        if ("" != e) {
            for (var t = "", i = e.split(","), a = 0; a < i.length; a++) i[a] == this.queryParams.limit ? t += '<li><a class="utils-showby-item active" href="' + i[a] + '">' + i[a] + "</a></li>" : t += '<li><a class="utils-showby-item" href="' + i[a] + '">' + i[a] + "</a></li>";
            var r = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, t);
            r = jQ.parseHTML(r), jQ(this.selector.topShowLimit).html(r)
        }
    }
}, BCSfFilter.prototype.buildShowLimitEvent = function() {
    var e = this;
    jQ(this.selector.topShowLimit + " li a").click(function(t) {
        onInteractWithToolbar(t, "limit", e.queryParams.limit, jQ(this).attr("href"))
    })
}, BCSfFilter.prototype.buildBreadcrumb = function(e, t) {
    if (void 0 !== e && e.hasOwnProperty("collection")) {
        var i = e.collection,
            a = '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + "</a> ";
        a += '<span class="breadcrumbs-delimiter" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5"><path fill="currentColor" fill-rule="evenodd" d="M1.002.27L.29.982l3.712 3.712L7.714.982 7.002.27l-3 3z"/></svg></span>', a += " <span>" + i.title + "</span>", a = jQ.parseHTML(a), jQ(".breadcrumbs-container").html(a)
    }
}, BCSfFilter.prototype.buildFilterDisplayType = function() {
    var e = '<span class="utils-viewtoggle-label">' + bcSfFilterConfig.label.view_as_title + " </span>";
    e += '<button class="active bc-sf-filter-display-grid" data-display-type="' + this.buildToolbarLink("grid_list", "list-view", "grid-view") + '">', e += '<svg class="icon-grid " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">      <path fill="currentColor" fill-rule="nonzero" d="M2 0h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 2v16h16V2H2zm3 3h4v4H5V5zm6 0h4v4h-4V5zm-6 6h4v4H5v-4zm6 0h4v4h-4v-4z"></path>    </svg>', e += '<button class="bc-sf-filter-display-list" data-display-type= "' + this.buildToolbarLink("grid_list", "grid-view", "list-view") + '">', e += '<svg class="icon-list " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">      <path fill="currentColor" fill-rule="nonzero" d="M2 0h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 2v16h16V2H2zm3 3h10v2H5V5zm0 4h10v2H5V9zm0 4h10v2H5v-2z"></path>    </svg>', e = jQ.parseHTML(e), jQ(this.selector.topDisplayType).html(e), jQ(this.selector.topDisplayType).find("button").removeClass("active"), "list-view" == this.queryParams.grid_list ? jQ(this.selector.topDisplayType).find("button.bc-sf-filter-display-list").addClass("active") : jQ(this.selector.topDisplayType).find("button.bc-sf-filter-display-grid").addClass("active")
}, BCSfFilter.prototype.buildDisplayTypeEvent = function() {
    var e = this;
    jQ(this.selector.topDisplayType + " button").unbind("click"), jQ(this.selector.topDisplayType + " button").click(function(t) {
        t.preventDefault(), e.internalClick = !0, jQ(this).parent().children("button").removeClass("active"), jQ(this).addClass("active");
        var i = jQ(this).attr("data-display-type"); - 1 != i.indexOf("list-view") ? (jQ(".productgrid--outer").removeClass("productgrid-gridview"), jQ(".productgrid--outer").addClass("productgrid-listview")) : (jQ(".productgrid--outer").removeClass("productgrid-listview"), jQ(".productgrid--outer").addClass("productgrid-gridview")), e.onChangeData(i, "grid_list")
    })
}, BCSfFilter.prototype.buildExtrasProductList = function(e, t) {
    "undefined" != typeof StampedFn && "function" == typeof StampedFn.loadBadges && StampedFn.loadBadges()
}, BCSfFilter.prototype.buildAdditionalElements = function(e, t) {
    window.bcInitEmpire && "function" == typeof bcInitEmpire && (jQ('[data-section-type="static-recently-viewed"]').length > 0 && jQ('[data-section-type="static-recently-viewed"]').attr("data-section-type", "bc-static-recently-viewed"), jQ('[data-section-type="static-header"]').length > 0 && jQ('[data-section-type="static-header"]').attr("data-section-type", "bc-static-header"), bcInitEmpire(), jQ('[data-section-type="bc-static-recently-viewed"]').length > 0 && jQ('[data-section-type="bc-static-recently-viewed"]').attr("data-section-type", "static-recently-viewed"), jQ('[data-section-type="bc-static-header"]').length > 0 && jQ('[data-section-type="bc-static-header"]').attr("data-section-type", "static-header"))
}, BCSfFilter.prototype.buildDefaultElements = function() {
    var e = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
        t = /Safari/.test(navigator.userAgent),
        i = window.performance && window.performance.navigation && 2 == window.performance.navigation.type;
    if (!(e && t && i)) {
        var a = window.location.href.split("?")[0],
            r = this.isSearchPage() && this.queryParams.hasOwnProperty("q") ? "&q=" + this.queryParams.q : "";
        window.location.replace(a + "?view=bc-original" + r)
    }
}, BCSfFilter.prototype.prepareProductData = function(e) {
    for (var t = e.length, i = 0; i < t; i++) {
        e[i].images = e[i].images_info, e[i].images.length > 0 ? e[i].featured_image = e[i].images[0] : e[i].featured_image = {
            src: bcSfFilterConfig.general.no_image_url,
            width: "",
            height: "",
            aspect_ratio: 0
        }, e[i].url = "/products/" + e[i].handle;
        for (var a = [], r = e[i].options_with_values.length, s = 0; s < r; s++) a.push(e[i].options_with_values[s].name);
        e[i].options = a;
        var l = e[i].variants[0],
            o = !0;
        if (l.hasOwnProperty("fulfillment_service") && "gift_card" == l.fulfillment_service && (o = !1), void 0 !== this.convertPriceBasedOnActiveCurrency && (e[i].price_min = this.convertPriceBasedOnActiveCurrency(e[i].price_min, o), e[i].price_max = this.convertPriceBasedOnActiveCurrency(e[i].price_max, o), e[i].compare_at_price_min = this.convertPriceBasedOnActiveCurrency(e[i].compare_at_price_min, o), e[i].compare_at_price_max = this.convertPriceBasedOnActiveCurrency(e[i].compare_at_price_max, o)), e[i].price_min *= 100, e[i].price_max *= 100, null != e[i].compare_at_price_min && (e[i].compare_at_price_min *= 100), null != e[i].compare_at_price_max && (e[i].compare_at_price_max *= 100), e[i].price = e[i].price_min, e[i].compare_at_price = e[i].compare_at_price_min, e[i].price_varies = e[i].price_min != e[i].price_max, null !== getParam("variant") && "" != getParam("variant")) {
            var c = e[i].variants.filter(function(e) {
                return e.id == getParam("variant")
            });
            void 0 !== c[0] && (l = c[0])
        } else {
            var n = e[i].variants.length;
            for (s = 0; s < n; s++)
                if (e[i].variants[s].available) {
                    l = e[i].variants[s];
                    break
                }
        }
        e[i].selected_or_first_available_variant = l;
        for (n = e[i].variants.length, s = 0; s < n; s++) {
            var p = [],
                m = e[i].variants[s].merged_options;
            if (Array.isArray(m)) {
                for (var d = m.length, g = 0; g < d; g++) {
                    var u = m[g].split(":");
                    e[i].variants[s]["option" + (parseInt(g) + 1)] = u[1], e[i].variants[s]["option_" + u[0]] = u[1], p.push(u[1])
                }
                e[i].variants[s].options = p
            }
            if (null != e[i].variants[s].compare_at_price) {
                var h = parseFloat(e[i].variants[s].compare_at_price);
                void 0 !== this.convertPriceBasedOnActiveCurrency && (h = this.convertPriceBasedOnActiveCurrency(h, o)), e[i].variants[s].compare_at_price = 100 * h
            }
            var v = parseFloat(e[i].variants[s].price);
            void 0 !== this.convertPriceBasedOnActiveCurrency && (v = this.convertPriceBasedOnActiveCurrency(v, o)), e[i].variants[s].price = 100 * v
        }
        e[i].description = e[i].content = e[i].body_html, e[i].hasOwnProperty("original_tags") && e[i].original_tags.length > 0 && (e[i].tags = e[i].original_tags.slice(0)), e[i].json = customizeJsonProductData(e[i])
    }
    return e
};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
